module.exports = __webpack_public_path__ + "static/media/ContasPagRec1.184c5f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec1.png
// module id = 2010
// module chunks = 0